import React from 'react'
import { IoHome } from 'react-icons/io5'
import { BookList } from '../components/BookList'
import { BackButton } from '../components/BackButton'

export function BookListPage() {
  return (
    <>
      <BackButton to="/" icon={<IoHome data-set="user-icon" />}>
        <span>Home</span>
      </BackButton>
      <BookList />
    </>
  )
}
